import React from 'react';
import styles from './StationHealth.module.scss';
import classNames from 'classnames';
import { statusToMessageMap } from '../../constants/health';

import WarningIcon from '@mui/icons-material/Warning';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import type { JetsonHealthDTO } from '../../types/jetson';

interface StationHealthProps {
  stationHealth: JetsonHealthDTO;
}

const StationHealth: React.FC<StationHealthProps> = ({ stationHealth }) => {
  const { message, status } = statusToMessageMap[stationHealth.status];
  return (
    <div
      className={classNames(styles.container, {
        [styles.up]: status === 'up',
        [styles.issue]: status === 'issue',
        [styles.down]: status === 'down',
      })}
    >
      <span className={styles.title}>{`RACK ${stationHealth.rackNum}`}</span>
      <div className={styles.statusContainer}>
        {status === 'up' && <CheckBoxIcon />}
        {status === 'issue' && <WarningIcon />}
        {status === 'down' && <WifiOffIcon />}
        <span className={styles.title}>{message}</span>
      </div>
    </div>
  );
};

export default StationHealth;
